import {WeatherForecastMetadata} from '../../api/types';
import {NormalizedForecastModel} from './types';

const MULTIMODEL_KEY = 'SMARTMIXIN_MULTIMODEL';

export const getLatestRunName = (
  forecastModel: NormalizedForecastModel | undefined,
  metadata: WeatherForecastMetadata | undefined,
): string | null => {
  if (!forecastModel || forecastModel.key === MULTIMODEL_KEY) {
    return null;
  }
  if (!metadata || !metadata.runs || metadata.runs.length === 0) {
    return null;
  }
  return metadata.runs
    .slice()
    .sort((a, b) => b.run.name.localeCompare(a.run.name))[0].run.name;
};
